import { Tooltip } from '@mui/material'
import React from 'react'
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom'
import { useStyleProductResume } from '@/components/Product/ProductResume'
import { Product } from '@/src/types/api-types'
import { ProductsBasket } from '@/type/basket'
import clsx from 'clsx'

type Props = {
  product: Product | ProductsBasket
  style?: React.CSSProperties
  className?: string
}

const InformationPeremption: React.FC<Props> = ({ product, style = null, className }) => {
  const classesResume = useStyleProductResume({})

  if (!product?.information_erp) return null
  return (
    <Tooltip title={'DLC'}>
      <div
        className={clsx(classesResume.rootInfoProduct, className)}
        style={{ marginTop: 16, ...style }}
      >
        <div className={classesResume.svgInfoProduct}>
          <HourglassBottomIcon width={20} height={20} />
        </div>
        <div className={classesResume.infoProduct}>{product.information_erp}</div>
      </div>
    </Tooltip>
  )
}

export default InformationPeremption
